/* 文档地址: https://wiki.didapinche.com/index.php?title=APP_JS%E6%8E%A5%E5%8F%A3%E8%AF%B4%E6%98%8E#APP.E6.8E.A5.E5.8F.A3 */
const GLoBal = {
  QUERY:[], // 存储为初始化调用的方法
  jsBridge:null,
  __isInited: false  // 是否完成初始化
}
function INITWEBVIEW(){
  this.setTopEnv(GLoBal);
  this.__init();
}
INITWEBVIEW.prototype.setTopEnv = function (GLoBal){
  try {
    GLoBal.__window = window.top;
    GLoBal.__document = window.top.document;
  } catch (e) {
    GLoBal.__window = window;
    GLoBal.__document = window.document;
  }
}

INITWEBVIEW.prototype.__init = function() {
  if (GLoBal.__window.WebViewJavascriptBridge) {
    this.__resolveInit();
  } else {
    GLoBal.__document.addEventListener(
      'WebViewJavascriptBridgeReady',
      this.__resolveInit.bind(this),
      false
    );
    if (!GLoBal.__window.WVJBCallbacks) {
      GLoBal.__window.WVJBCallbacks = [this.__resolveInit.bind(this)];
    } else if (GLoBal.__window.WVJBCallbacks && GLoBal.__window.WVJBCallbacks.push) {
      GLoBal.__window.WVJBCallbacks = GLoBal.__window.WVJBCallbacks.push(this.__resolveInit.bind(this));
    }
    const WVJBIframe = GLoBal.__document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    GLoBal.__document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
      GLoBal.__document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }
}
INITWEBVIEW.prototype.__resolveInit = function(){
  if (!GLoBal.__isInited && GLoBal.__window.WebViewJavascriptBridge) {
    GLoBal.__isInited = true;
    GLoBal.jsBridge = GLoBal.__window.WebViewJavascriptBridge;
    while(GLoBal.QUERY.length >0){
      let obj = GLoBal.QUERY.pop();
      if(obj.type === 'registerHandler'){
        GLoBal.jsBridge.registerHandler(obj.methodName, obj.callBack);
      } else {
        GLoBal.jsBridge.callHandler(obj.methodName, obj.data, obj.callBack);
      }
    }
  }
}

// 注册方法,供app调用
INITWEBVIEW.prototype.registerHandler = function(methodName, data, callBack) {
  if(GLoBal.__isInited){
    GLoBal.jsBridge.registerHandler(methodName, callBack);
  } else {
    GLoBal.QUERY.push({
      callBack: callBack,
      methodName: methodName,
      type: 'registerHandler' 
    });
  }
}
// 调用app方法
INITWEBVIEW.prototype.callHandler = function(methodName, data, callBack) {
  if(GLoBal.__isInited){
    GLoBal.jsBridge.callHandler(methodName, data, callBack);
  } else {
    GLoBal.QUERY.push({
      callBack:  callBack,
      methodName:  methodName,
      data:  data,
      type: 'callHandler' 
    });
  }
}


export default INITWEBVIEW
